var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCactus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.3431 2 9 3.34315 9 5V12H7C6.44772 12 6 11.5523 6 11V9C6 7.89543 5.10457 7 4 7C2.89543 7 2 7.89543 2 9V12C2 14.2091 3.79086 16 6 16H9V21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H15V19H18C20.2091 19 22 17.2091 22 15V11C22 9.89543 21.1046 9 20 9H19.8C18.6954 9 17.8 9.89543 17.8 11V13.7143C17.8 14.2666 17.3523 14.7143 16.8 14.7143H15V7.98723C15.8502 7.93482 17.0709 7.70518 17.8884 6.88761C18.8195 5.95648 18.9876 4.50269 18.9999 3.66884C19.0056 3.28815 18.7115 2.99431 18.3308 3.00008C17.4967 3.01273 16.0426 3.18126 15.1116 4.11239C15.0448 4.1792 14.9819 4.24871 14.9227 4.32049C14.6148 2.99095 13.4231 2 12 2ZM12.75 21.25H11.25V15C11.25 14.5858 11.5858 14.25 12 14.25C12.4142 14.25 12.75 14.5858 12.75 15V21.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCactus);
export default __webpack_public_path__ + "static/media/cactus.b4675533ecbaf8848da07a63240c8e66.svg";
export { ForwardRef as ReactComponent };